module.exports = ".grid{\r\n    margin-bottom:2px;\r\n}\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/masters/customer-creation-grid/customer-creation-grid.component.css
// module id = ./src/app/masters/customer-creation-grid/customer-creation-grid.component.css
// module chunks = main